export class Group {
    id: number;
    groupName: string;
    status: string;
    isDeleted: boolean = false;
   
}

